module.exports = __webpack_public_path__ + "img/61_13.a251f787.png";